'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'name': '@okta/okta-react',
  'version': '1.4.1'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/okta-react/dist/packageInfo.js
// module id = 302
// module chunks = 0